/**
 * @property {number} quantity quantity
 * @property  {string} [productId] id of the product
 * @property {string} [version] version of the product
 * @property {string} shipmentId The shipment id
 */
export class ShipmentParcelContent {
  quantity: number;
  shipmentId: string;

  constructor(parcel?: Partial<ShipmentParcelContent>) {
    this.quantity = parcel?.quantity ?? 0;
    this.shipmentId = parcel?.shipmentId ?? '';
  }
}
